<template>
  <div class="list-item">
    <div class="list-item-title">
      <div class="query-title" @click="toDetail(item.id, item.type)" v-html="item.title"></div>
      <div class="list-item-right">
        <span class="info-item" v-if="isFaq">{{ item.categoryName}}</span>
        <span class="info-item">{{new Date(item.updateDate).format("yyyy-MM-dd hh:mm:ss") || ""}}</span>
        <div class="info-item" v-if="isFaq">
          <a-icon type="like" />{{ item.likesNum || 0 }}
        </div>
        <div class="info-item">
          <a-icon type="eye" />{{ item.readCount || 0 }}
        </div>
      </div>
    </div>
    <p class="list-item-keyword" v-if="isFaq">
      <span>关键词：</span>
      <span :title="item.keyWord" v-html="item.keyWord"></span>
    </p>
    <div class="list-item-content" @click.capture="handleExpand(item)">
      <span :class="[
        'text',
        { expand: isExpand },
        { 'no-pointer': !isShowExpand(item.content) },
      ]" v-text="item.content">
      </span>
      <a class="opt-btn pos-self mvt-5" href="javascript:void(0)" v-if="isShowExpand(item.content) && isExpand">
        收起
        <a-icon type="up" :style="{ fontSize: '12px' }" />
      </a>
      <a class="opt-btn" href="javascript:void(0)" v-else-if="isShowExpand(item.content) && !isExpand">
        查看更多
        <a-icon type="right" :style="{ fontSize: '12px' }" />
      </a>
    </div>
  </div>
</template>
<script>
import { checkNoLoginRead, setLikesOrCancel, getVuepressUrl } from "../../../api/faq";
import { getCookie } from "@/utils/common";
export default {
  name: "list-item",
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isExpand: false,
      isLikes: false,
      isDislike: false,
    };
  },
  computed:{
    isFaq(){
      return this.item.type == 'faq';
    }
  },
  methods: {
    /**
     * 是否显示 “展开全部"
     */
    isShowExpand(str) {
      var isShowExpand = false;
      if (str && str.length / 68 >= 1) {
        isShowExpand = true;
      }
      return isShowExpand;
    },

    /**
     * 点击展开
     * @param id [Number] 当前点击的问题的id
     * @param content [String] 当前点击的问题的内容
     */
    handleExpand({ id, type, content, show }) {
      var str = content;
      this.curExpandId = id;
      if (str) {
        if (type == "faq") {
          checkNoLoginRead(id).then((res) => {
            if (res && !res.data.checkNoLoginRead) {
              let cookie = getCookie('loginKey');
              if (!cookie) {
                this.$warning({ content: '未登录，无法查看此FAQ，请先登录！' })
                return;
              }
            }
          });
        }
        if (str.length / 68 >= 1 && str.length / 68 < 10 && !show) {
          this.isExpand = !this.isExpand;
        } else if (str.length / 68 >= 10 || show) {
          this.toDetail(id, type);
        }
      }
    },

    /**
     * 点击打开详情页弹窗
     */
    toDetail(id, type) {
      if (type == "vuepress") {
        getVuepressUrl(id).then((res) => {
          if (res && res.data.url) {
            window.open(res.data.url);
          }
        });
      } else {
        checkNoLoginRead(id).then((res) => {
          if (res && !res.data.checkNoLoginRead) {
            let cookie = getCookie('loginKey');
            if (!cookie) {
              this.$warning({ content: '未登录，无法查看此FAQ，请先登录！' })
              return;
            }
          }
          this.$emit("toDetail", id);
        });
      }
    },

    /**
     * 点赞 (列表页暂不做点赞功能，仅展示数据)
     */
    handleLikes(id, isLike) {
      // 判断是否有token，如果没有就跳转到登录页/提示登录后才能做此操作
      if (!sessionStorage.getItem("token")) {
        // 1. 转到登录
        // window.location.href = '/login';
        // 2. 弹窗提示
        this.$warning({
          title: "提示",
          content: "此操作需要登录",
        });
        return;
      }

      // 判断该操作是 点赞 还是 取消点赞
      var type = !isLike ? "like" : "hate";
      setLikesOrCancel(id, type).then((res) => {
        if (res.code != 200) {
          return;
        }
        try {
          if (type == "like") {
            this.curQueryObj.likesNum += 1;
          } else if (type == "hate") {
            this.curQueryObj.likesNum -= 1;
          }
          this.$emit("likesAdd", id, type);
          // 改变样式
          this.isLikes = !this.isLikes;
        } catch (error) {
          this.$error({
            title: error.message,
          });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.list-item {
  margin: 16px 0;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 18px 20px;
  font-size: 12px;

  &-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #999999;
    margin-bottom: 12px;
    .info-item{
      display: inline-block;
      i{
        margin-right: 4px;
      }
    }
    .info-item + .info-item{
      margin-left: 15px;
    }

  }

  .query-title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: Semibold;
    text-align: left;
    color: #000000;
  }
  .query-title:hover {
    color: #0077ff;
  }
}

.list-item-content {
  position: relative;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.list-item-content .text {
  width: calc(100% - 90px);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  cursor: pointer;
  font-size: 14px;
}

/* 不超过一行时，不出现手型光标 */
.list-item-content .text.no-pointer {
  cursor: default;
}

.list-item-content .text.expand {
  overflow: auto;
  display: inline-block;
}

.opt-btn {
  position: absolute;
  right: 0;
  top: 0;
  width: 90px;
  display: inline-block;
  text-align: right;
  font-size: 14px;
}

.opt-btn.pos-self {
  position: relative;
}

.mvt-5 {
  top: -5px;
}

::v-deep .ant-divider-horizontal {
  margin: 16px 0 20px;
}

@media screen and (max-width: 824px) {
  .list-item-title{
    flex-direction: column;
    align-items: flex-start;
  }
  .list-item-title,.query-title,.list-item-keyword{
    margin-bottom: 6px;
  }
}

</style>